import type { UserSettings } from "./types";

export const DEFAULT_USERNAME = "Default";

export const settingsMock: UserSettings = {
  user: "test@test.com",
  settings: [
    {
      name: "Suggest Reports",
      type: "boolean",
      available_options: [true, false],
      default_option: false,
      display_type: "Switch",
    },
    {
      name: "Chatbot Personality",
      type: "string",
      available_options: ["basic", "enthusiastic", "snoop dog"],
      default_option: "basic",
      display_type: "Radio",
    },
    {
      name: "Language",
      type: "string",
      available_options: ["english"],
      default_option: "english",
      display_type: "Dropdown",
    },
  ],
  recommended_prompt: [
    {
      user_prompt_fe: "Show me a number of reservations from last month.",
      user_prompt_be: "Show me a number of reservations from last month.",
      type: "popularity",
    },
    {
      user_prompt_fe: "How many guests or profiles are there?",
      user_prompt_be: "How many guests or profiles are there?",
      type: "popularity",
    },
    {
      user_prompt_fe: "What is the most popular room type?",
      user_prompt_be: "What is the most popular room type?",
      type: "popularity",
    },
    {
      user_prompt_fe:
        "How many reservations from BOOKING (Source - Sub Source Name) last month?",
      user_prompt_be:
        "How many reservations from [Dim_Sources].[Sub Source Name] = 'BOOKING' last month?",
      type: "ai-assisted",
    },
  ],
};
